"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { tableCustomAction } from "UserActionHandler/UserScriptActions";
import { Fields, System } from "Constants/objects";
import { toolbarTableKeyboardEvents } from "Actions/Table/TableToolBarActions";
import Columns from "Stores/Table/core/table/Columns";
import { Model } from "Model";
import { sharedData } from 'SharedData';
import TableFilterEditor from "D5Utils/filter_editor/TableFilterEditor";
import { checkIfUserScriptExists, formatText, getAddSSFilter, getSSTableCols, isDateByTypeStr, isEmptyObject, isEmptyValue, isLookup, setAddSSFilter, setSSTableCols } from "D5Utils/functions";
import { HeaderFilterDS } from "Stores/Table/core/table/DataSource";
import Configurator from "Stores/Table/core/table/Configurator";
import { loadObjectData } from "D5Utils/common_requests";
import { d5SendNestedDataToForm, d5TableFilterSaved } from "Actions/Table/D5TableActions";
import FieldsFactory from "D5Utils/FieldsFactory";
import { Messages } from "Messages";

var Rows =
/*#__PURE__*/
function () {
  /**
   * @param {Configurator} settings
   */
  function Rows(_ref) {
    var settings = _ref.settings;

    _classCallCheck(this, Rows);

    this.settings = settings;
    this.filterEditors = new Map();
    this.prepareDataRow = this.prepareDataRow.bind(this);
  }

  _createClass(Rows, [{
    key: "setupEditor",
    value: function setupEditor(event) {
      var _this = this;

      var _event$row = event.row,
          data = _event$row.data,
          key = _event$row.key;
      this.onEditorPreparing(_objectSpread({}, data), key, event.dataField).then(function (result) {
        if (!result) {
          return;
        }

        _this.prepareDataRow(event);
      });
    }
  }, {
    key: "onEditorPreparing",
    value: function () {
      var _onEditorPreparing = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(rowData, key, dataField) {
        var sourceRow, views;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sourceRow = Configurator.columnDataToSourceData({
                  data: rowData,
                  viewSource: this.settings.viewSource,
                  instance: this.settings.instance()
                });
                _context.next = 3;
                return this.settings.onEditorPreparing({
                  sourceRow: sourceRow,
                  key: key,
                  dataField: dataField
                });

              case 3:
                views = _context.sent;
                this.settings.viewSource = this.settings.viewSource.map(function (view) {
                  var next = views.find(function (nv) {
                    return nv.Name === view.Name;
                  });

                  if (next && next[System._Changed]) {
                    next[System._Changed] = false;
                    return next;
                  }

                  return view;
                });
                this.settings.updating = false;
                return _context.abrupt("return", true);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onEditorPreparing(_x, _x2, _x3) {
        return _onEditorPreparing.apply(this, arguments);
      }

      return onEditorPreparing;
    }()
  }, {
    key: "prepareDataRow",
    value: function prepareDataRow(e) {
      var _this2 = this;

      var _this$settings = this.settings,
          filtersData = _this$settings.filtersData,
          objectName = _this$settings.objectName,
          formUUID = _this$settings.formUUID,
          formName = _this$settings.formName;
      var skip = false;
      var field = this.settings.getFieldByName(e.dataField) || {};
      var dictionaryObj = field[Fields.ObjectFieldID_LinkedObjectID_Name],
          dictionaryDisplayFld = field[Fields.DisplayField],
          dictionaryKeyFld = field[Fields.ObjectFieldID_KeyObjectFieldID_Name];
      var colType = Columns.getColumnType(field);

      var type = function () {
        if (Columns.isLookup(field)) return System.FIELD_EDITOR_TYPE.SELECT;
        if (colType === 'boolean') return System.FIELD_EDITOR_TYPE.BOOL_CB;
        return colType;
      }();

      _.each(filtersData, function (value, key) {
        var fields = _.filter(_this2.settings.viewSource, function (item) {
          return (item[Fields.ObjectFieldID_Name] === key || item[Fields.KeyFilterField] === key) && !Columns.isSystemField(item);
        });

        _.each(fields, function (field) {
          if (e.dataField === field.Name) {
            skip = true;
          }
        });
      });

      if (skip) return;
      var value = isLookup(field) ? this.settings.editingRowInfo[System.SYSTEM_PREFIX + e.dataField] : this.settings.editingRowInfo[e.dataField];

      if (colType === 'boolean') {
        value = Boolean(value);
      }

      var props = {
        dataField: e.dataField,
        objectName: objectName,
        dType: colType,
        _id: "table-editor-".concat(e.dataField),
        dataSource: new HeaderFilterDS(dictionaryObj, dictionaryKeyFld, dictionaryDisplayFld, field['_filter']).dataSource(),
        displayExpr: dictionaryDisplayFld,
        valueExpr: dictionaryKeyFld,
        value: value,
        allowNullState: false,
        onKeyDown: function onKeyDown(_ref2) {
          var event = _ref2.event;

          if (event.keyCode === 45 && _this2.settings.inlineEditing()) {
            toolbarTableKeyboardEvents(formUUID, event);
          }
        },
        onValueChanged: function onValueChanged(_ref3) {
          var value = _ref3.value,
              component = _ref3.component,
              previousValue = _ref3.previousValue;
          if (JSON.stringify(value) === JSON.stringify(previousValue)) return;
          var val = value;

          if (colType === 'boolean') {
            val = Boolean(val);
          }

          _this2.settings.editingRowInfo[e.dataField] = val;

          if (isLookup(field)) {
            _this2.settings.editingRowInfo[System.SYSTEM_PREFIX + e.dataField] = val;
          }

          if (isLookup(field)) {
            var masterEv = '';

            if (typeof field.OnMasterSelectFilter === "function") {
              masterEv = 'OnMasterSelectFilter';
              console.warn(Messages.Warning.OnMasterSelectFilterDeprecated);
            } else if (typeof field.onMasterSelectFilter === "function") masterEv = 'onMasterSelectFilter';

            if (typeof field[masterEv] === "function") {
              _this2.settings.updating = masterEv;
              var model = field[masterEv](_this2.settings.viewSource, Configurator.columnDataToSourceData({
                data: _this2.settings.editingRowInfo,
                viewSource: _this2.settings.viewSource,
                instance: _this2.settings.instance()
              }));
              tableCustomAction({
                fileName: formName,
                funcName: masterEv,
                nextStore: model.getSourceData(),
                viewStore: model.getSourceView(),
                formUUID: formUUID,
                rowIndex: e.row.rowIndex,
                props: {
                  formOperation: _this2.settings.inlineEditing() === 'add' ? 'Ins' : 'Mod',
                  owner: _this2.settings._owner,
                  filter: {
                    formFields: _this2.settings.viewSource,
                    viewSource: _this2.settings._formFilters,
                    lsColumns: getSSTableCols(_this2.settings.getLSName()),
                    addFilter: getAddSSFilter(_this2.settings.getLSName())
                  }
                }
              });
            }
          }

          _this2.saveCell(e.row.rowIndex, field, e.setValue, val, component.option('displayValue'));
        }
      };
      var editor = FieldsFactory.create(type, props);
      editor.render();
      editor.element().appendTo(e.editorElement);
      this.settings.colSetValueFuncs.set(e.dataField, e.setValue);
    }
    /**
     * @param {number} rowIndex
     * @param {object} field FormFields
     * @param {function} setValue
     * @param {any} value
     * @param {string} [displayValue] only for dictionaries
     */

  }, {
    key: "saveCell",
    value: function saveCell(rowIndex, field, setValue, value) {
      var displayValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      var _this$settings2 = this.settings,
          editMode = _this$settings2.editMode,
          formUUID = _this$settings2.formUUID;
      var CELL = System.EDIT_MODE.CELL;
      var dataField = field.Name;
      var eventName = this.getEventNameByField(field.ID, System.USER_EVENT_TYPE.ON_VALUE_CHANGED);

      if (eventName) {
        this.emitUserEvent(eventName, formUUID, rowIndex);
        return;
      }

      if (isLookup(field)) {
        setValue(displayValue);
        this.settings.instance().cellValue(rowIndex, System.SYSTEM_PREFIX + dataField, value);
      } else {
        setValue(value);
      }

      if (editMode === CELL) {
        this.settings.instance().saveEditData();
      }
    }
  }, {
    key: "emitUserEvent",
    value: function emitUserEvent(eventName, formUUID, rowIndex) {
      if (this.settings.updating) {
        return;
      }

      if (eventName && sharedData.inlineEditing) {
        this.settings.updating = eventName;
        var data = this.settings.editingRowInfo;
        tableCustomAction({
          fileName: this.settings.formName,
          funcName: eventName,
          nextStore: Configurator.columnDataToSourceData({
            data: data,
            viewSource: this.settings.viewSource,
            instance: this.settings.instance()
          }),
          viewStore: this.settings.viewSource,
          formUUID: formUUID,
          rowIndex: rowIndex,
          props: {
            formOperation: this.settings.inlineEditing() === 'add' ? 'Ins' : 'Mod',
            owner: this.settings._owner,
            filter: {
              formFields: this.settings.viewSource,
              viewSource: this.settings._formFilters,
              lsColumns: getSSTableCols(this.settings.getLSName()),
              addFilter: getAddSSFilter(this.settings.getLSName())
            }
          }
        });
      }
    }
  }, {
    key: "sendNestedData",
    value: function sendNestedData() {
      var _this3 = this;

      var data = this.settings.instance().option('dataSource');
      var out = [];

      _.each(data, function (row) {
        var obj = {};

        _.each(_this3.settings.columnNames, function (name) {
          var field = _this3.settings.getFieldByName(name);

          if (Columns.isSystemField(field)) return;

          if (isLookup(field)) {
            obj[field[Fields.KeyFilterField]] = row[System.SYSTEM_PREFIX + name];
            obj[field[Fields.ObjectFieldID_Name]] = row[name];
          } else {
            obj[field[Fields.ObjectFieldID_Name]] = row[name];
          }
        });

        out.push(obj);
      });

      d5SendNestedDataToForm({
        data: out,
        parentFormID: this.settings.parentFormID,
        subFormID: this.settings.formID
      });
    }
  }, {
    key: "submitRow",
    value: function submitRow(_ref4) {
      var _this4 = this;

      var sourceData = _ref4.sourceData,
          key = _ref4.key;

      if (sourceData && isEmptyObject(sourceData)) {
        return Promise.resolve({});
      }

      var objName = this.settings.objectName;

      if (this.settings.inlineEditing() === System.FORM_EDIT_CREATE_MODE.EDIT) {
        sourceData[this.settings.keyField] = key;
      } else {
        delete sourceData[this.settings.keyField];
      }

      return new Promise(function (resolve) {
        var ObjectModel = Model.extend({
          initialize: function initialize() {
            this.object = objName;
          },
          idAttribute: _this4.settings.keyField
        });
        var model = new ObjectModel();
        model.save(sourceData, {
          success: function success(res) {
            var respKey = res.get(_this4.settings.keyField) || key;
            loadObjectData({
              objectName: objName,
              filter: _defineProperty({}, _this4.settings.keyField, respKey),
              columns: _this4.settings.requestColumns
            }).then(function (respData) {
              resolve({
                respKey: respKey,
                respData: respData
              });
            });
          },
          error: function error(model, response) {
            resolve({
              respData: sourceData,
              error: response.ResponseText
            });
          }
        });
      });
    }
  }, {
    key: "filterCell",
    value: function filterCell(col, editorElement) {
      var _this5 = this;

      var _ref5 = col.userData || {},
          dictionaryObj = _ref5.dictionaryObj,
          dictionaryDisplayFld = _ref5.dictionaryDisplayFld,
          dictionaryKeyFld = _ref5.dictionaryKeyFld,
          keyFilterField = _ref5.keyFilterField,
          allowFiltering = _ref5.allowFiltering;

      var _System$FIELD_EDITOR_ = System.FIELD_EDITOR_TYPE,
          BOOL_SB = _System$FIELD_EDITOR_.BOOL_SB,
          DATETIME = _System$FIELD_EDITOR_.DATETIME,
          DATE = _System$FIELD_EDITOR_.DATE,
          SELECT = _System$FIELD_EDITOR_.SELECT,
          MULTI_SELECT = _System$FIELD_EDITOR_.MULTI_SELECT;
      if (!col.dataField || col.dataField.indexOf(System.SYSTEM_PREFIX) === 0) return;
      var tableField = this.settings.getFieldByName(col.dataField);
      var filterField = this.settings._formFilters.find(function (f) {
        return f[Fields.ObjectFieldID] === tableField[Fields.ObjectFieldID];
      }) || {};

      var type = function () {
        if (dictionaryObj && dictionaryDisplayFld) {
          return !isEmptyObject(filterField) && !filterField[Fields.IsMultiselect] ? SELECT : MULTI_SELECT;
        }

        if (col.dataType === 'boolean') return BOOL_SB;else if (col.dataType === DATETIME) return DATE;
        return col.dataType;
      }();

      var initDropDown = function initDropDown(e) {
        setTimeout(function () {
          var $overlay = $(".dx-dropdowneditor-overlay"),
              $popupContent = $overlay.find('.dx-popup-content');
          $popupContent.css({
            'max-height': '278px'
          });
        });
      };

      var fValue = col.filterValue;

      if (isDateByTypeStr(col.dataType) && fValue) {
        if (Array.isArray(fValue) && col.realOperation !== 'between') {
          fValue = fValue.map(function (date) {
            return formatText(DATE, date);
          });
        }
      }

      var props = {
        dataField: col.dataField,
        objectName: this.settings.objectName,
        dType: col.dataType === DATETIME ? DATE : col.dataType,
        _id: "table-".concat(col.dataField),
        dataSource: new HeaderFilterDS(dictionaryObj, dictionaryKeyFld, dictionaryDisplayFld).dataSource(),
        displayExpr: dictionaryDisplayFld,
        valueExpr: dictionaryKeyFld,
        disabled: !allowFiltering,
        value: fValue,
        onValueChanged: function onValueChanged(_ref6) {
          var value = _ref6.value;
          if (_this5.settings.updating) return;

          var eventName = _this5.getFilterFieldEventNameByField(filterField[Fields.ID], System.USER_EVENT_TYPE.ON_VALUE_CHANGED);

          var lsColumns = getSSTableCols(_this5.settings.getLSName());
          var addFilter = getAddSSFilter(_this5.settings.getLSName());

          if (tableField) {
            _this5.editLSCol(lsColumns, col.dataField, {
              value: value
            });
          } else {
            if (addFilter[col.dataField]) {
              addFilter[col.dataField].filterValue = value;
            } else {
              addFilter[col.dataField] = {
                realOperation: '=',
                filterValue: value
              };
            }
          }

          if (eventName && checkIfUserScriptExists(_this5.settings.formName, eventName)) {
            _this5.settings.emitFilterFieldUserEvent({
              eventName: eventName,
              lsColumns: lsColumns,
              addFilter: addFilter,
              formUUID: _this5.settings.formUUID
            });

            return;
          }

          _this5.saveFilter(lsColumns, getAddSSFilter(_this5.settings.getLSName()));
        },
        onOpened: function onOpened(e) {
          if (type === SELECT || type === MULTI_SELECT) initDropDown(e);
        },
        onContentReady: function onContentReady(e) {
          if (type === SELECT || MULTI_SELECT === type) initDropDown(e);
        }
      };
      var editor = new TableFilterEditor({
        defOperation: col.userData && col.userData.realOperation,
        type: type,
        onOperationChanged: function onOperationChanged(operation) {
          if (_this5.settings.updating) return;
          _this5.settings.updating = 'onOperationChanged';
          var lsColumns = getSSTableCols(_this5.settings.getLSName());

          _this5.editLSCol(lsColumns, col.dataField, {
            value: editor.getValue(),
            realOperation: operation
          });

          _this5.saveFilter(lsColumns, getAddSSFilter(_this5.settings.getLSName()));
        }
      }, props);
      this.filterEditors.set(col.dataField, editor);
      editor.render();
      editor.element().appendTo(editorElement);
    }
  }, {
    key: "editLSCol",
    value: function editLSCol(lsColumns, dataField, options) {
      var value = options.value,
          realOperation = options.realOperation;
      var lsCol = lsColumns.find(function (c) {
        return c.dataField === dataField;
      });
      lsCol.filterValue = value;
      if (options.hasOwnProperty('realOperation')) lsCol.realOperation = realOperation;
    }
  }, {
    key: "saveFilter",
    value: function saveFilter(lsColumns, addFilter) {
      var lsKey = this.settings.getLSName();
      lsColumns.forEach(function (col) {
        if (isEmptyValue(col.filterValue)) delete col.filterValue;
      });
      setSSTableCols(lsKey, lsColumns);
      setAddSSFilter(lsKey, addFilter);
      d5TableFilterSaved({
        formUUID: this.settings.formUUID,
        sender: System.FILTER_SENDERS.TABLE
      });
    }
  }, {
    key: "getEventNameByField",
    value: function getEventNameByField(fieldID, eventType) {
      var fieldEvent = this.settings.userEvents.find(function (e) {
        return e[Fields.FormFieldID] === Number(fieldID) && e[Fields.EventTypeID] === eventType;
      });
      if (fieldEvent && fieldEvent[Fields.FunctionName]) return fieldEvent[Fields.FunctionName];
    }
  }, {
    key: "getFilterFieldEventNameByField",
    value: function getFilterFieldEventNameByField(fieldID, eventType) {
      var fieldEvent = this.settings.filterEvents.find(function (e) {
        return e[Fields.FormFilterFieldID] === Number(fieldID) && e[Fields.EventTypeID] === eventType;
      });
      if (fieldEvent && fieldEvent[Fields.FunctionName]) return fieldEvent[Fields.FunctionName];
    }
  }, {
    key: "getRowData",
    value: function getRowData(editMode) {
      var _this6 = this;

      var table = this.settings.instance();
      return new Promise(function (resolve) {
        var promises = [];

        if (System.FORM_EDIT_CREATE_MODE.ADD === editMode) {
          _.each(_this6.settings.filtersData || {}, function (value, key) {
            var fields = _.filter(_this6.settings.viewSource, function (item) {
              return (item[Fields.ObjectFieldID_Name] === key || item[Fields.KeyFilterField] === key) && !Columns.isSystemField(item);
            });

            _.each(fields, function (field) {
              if (Columns.isLookup(field)) {
                var displayFld = field[Fields.DisplayField];
                promises.push(loadObjectData({
                  filter: _defineProperty({}, Fields.ID, value),
                  columns: [Fields.ID, displayFld],
                  objectName: field[Fields.ObjectFieldID_LinkedObjectID_Name]
                }).then(function (data) {
                  var res = {};

                  if (data.length) {
                    res[field.Name] = data[0][displayFld];
                    res[System.SYSTEM_PREFIX + field.Name] = data[0][Fields.ID];
                  }

                  return Promise.resolve(res);
                }));
              } else {
                promises.push(Promise.resolve(_defineProperty({}, field.Name, value)));
              }
            });
          });

          if (promises.length) {
            Promise.all(promises).then(function (data) {
              var rowData = {};

              _this6.settings.columnNames.forEach(function (name) {
                return rowData[name] = null;
              });

              resolve(_objectSpread({}, rowData, (data || []).reduce(function (accum, curr) {
                return _objectSpread({}, accum, curr);
              }, {})));
            });
          } else {
            resolve({});
          }
        } else {
          resolve(table.getSelectedRowsData()[0]);
        }
      });
    }
  }]);

  return Rows;
}();

export { Rows as default };